import { Network } from 'relay-runtime';
import auth from '../../services/auth';

// Define a function that fetches the results of an operation (query/mutation/etc)
// and returns its results as a Promise:
function fetchQuery(
  operation,
  variables,
  cacheConfig,
  uploadables,
) {

  // const url = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV;
  const url = process.env.REACT_APP_NODE_ENV === 'production' ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_DEV;

  return fetch(`${url}/graphql`, {
    method: 'POST',
    headers: {
      'Authorization': 'Bearer ' + auth.token(),
    },
    body: JSON.stringify({
      query: operation.text,
      variables,
    }),
  }).then(response => {
    if (response.status === 401) {
      auth.logout();
    }
    return response.json();
  });
}

// Create a network layer from the fetch function
const network = Network.create(fetchQuery);

export default network;



// WEBPACK FOOTER //
// ./src/data/services/network.js